import { Box } from '@mui/material';
import { DialogUI, FileTabUI } from '../Interface';

const AttachmentDialogUI = ({ open, handleClose, data }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1300px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <FileTabUI savedFiles={data ?? []} />
      </Box>
    </DialogUI>
  );
};

export default AttachmentDialogUI;
